import axios from "axios";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import PsContext from "../../../context";

import { NEW_GIF } from "../../../utils/data";
import { ServiceUrl } from "../../../utils/serviceUrl";
import { DB_POSTFIX, themeColor } from "../../../utils";

const TopHeader = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    listData();
  }, []);

  const listData = () => {
    setLoader(true);
    axios
      .get(
        ServiceUrl.LIST_PAGES +
          "?sadb=" +
          DB_POSTFIX +
          "&type=announcement&upcoming=1&top_scroll=1"
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
        }
        setLoader(false);
      });
  };

  return (
    <div className="ed-top">
      <div className="container-fluid">
        <div className="row">
          <div
            className="col-md-8 d-flex justify-content-start align-items-center"
            style={{ backgroundColor: themeColor }}
          >
            <div className="ed-com-t1-left text-white">
              <ul>
                <li>
                  <a
                    href="https://portal.aei.edu.in/mob/#/stu/login"
                    className="text-white"
                    target="_blank"
                  >
                    Student Login
                  </a>
                </li>
                <li>
                  <a
                    href="https://portal.aei.edu.in/mob/#/staff/login"
                    className="text-white"
                    target="_blank"
                  >
                    Staff Login
                  </a>
                </li>
                <li>
                  <a
                    href="https://portal.aei.edu.in"
                    target="_blank"
                    className="text-white"
                  >
                    ERP Login
                  </a>
                </li>
                <li>
                  <a href="/about-us" className="text-white">
                    About
                  </a>
                </li>
                <li>
                  <a href="/contact-us" className="text-white">
                    Contact
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-4" style={{ backgroundColor: "#000000ff" }}>
            <div className="ed-com-t1-right text-white justify-content-end">
              <ul>
                <li>
                  <a href="/facilities" className="text-white">
                    Facilities
                  </a>
                </li>
                <li>
                  <a href="/aei" className="text-white">
                    AEI
                  </a>
                </li>
                <li>
                  <a
                    href={`https://portal.aei.edu.in/#/admission-enquiry?sadb=${DB_POSTFIX}`}
                    target="_blank"
                    className="text-white"
                  >
                    Admission
                  </a>
                </li>
                <li>
                  <a href="/faq" className="text-white">
                    FAQs
                  </a>
                </li>
                <li>
                  <a href="/alumni" className="text-white">
                    Alumni
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
